export const config = {
  // apiUrl: `http://ec2-35-175-13-4.compute-1.amazonaws.com:8010`,
  // Test URL
  //apiUrl: `http://ec2-35-174-193-249.compute-1.amazonaws.com`,
  // apiUrl: `http://ec2-34-230-167-131.compute-1.amazonaws.com:8010`,
  // UAT Database
  apiUrl: `https://${window.location.hostname}`,
  // Prod Replica URL
  //apiUrl: `http://ec2-35-175-13-4.compute-1.amazonaws.com:8010`,
  // UAT URL
  //apiUrl: `https://${window.location.hostname}`,
  // Python API base URL (user-management-service & entity-service)
  pythonUrl: `https://api.mytimesmart.com`,
  // Call Automation for Test
  //callAutomate: `https://ec2-18-232-204-138.compute-1.amazonaws.com:8016/callAutomate`,
  // Call Automation for UAT
  callAutomate: `https://ec2-34-230-167-131.compute-1.amazonaws.com:8016/callAutomate`,
  // Call Automation for document upload (process-multi)
  //callAutomateUpload: `https://contractai.timesmartai.org/api/contracts/process-multi`,
  callAutomateUploadAsync: `https://contractai.timesmartai.org/api/contracts/process-multi-async`,
  /**
   * Contract document process-multi service base URL (browser needs CORS or a same-origin gateway).
   * Optional: set REACT_APP_CONTRACT_PROCESS_MULTI_URL to override the full POST URL.
   * Optional: set contractProcessMultiGatewayPath to a path on `apiUrl` (uses dataSaver POST + auth).
   */
  contractProcessMultiServiceOrigin: `https://35.169.163.214:8004`,
  /** e.g. 'contract-managment-service/contracts/process-multi' — only if your API gateway exposes it */
  contractProcessMultiGatewayPath: null,
  // SMMC contract document upload (async job) service
  smmcContractUploadUrl: `https://35.169.163.214:8100/api/smmc/contracts/upload`,
};
